import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_EVENTS_ERROR, DELETE_EVENTS_START, DELETE_EVENTS_SUCCESS} from "../../types";

export function* deleteEvents({payload}) {
    try {
        const url = `/events/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_EVENTS_SUCCESS, results: results.data});
    } catch (error) {
        yield put({type: DELETE_EVENTS_ERROR, error});
    }
}

export default function* delete_events() {
    yield takeLatest(DELETE_EVENTS_START, deleteEvents);
}